import React from "react";
import { useTranslation } from "react-i18next";
import { StarIcon } from "@heroicons/react/solid";

const ConsultantBadge = ({ consultant }) => {
  const { t } = useTranslation();

  if (!consultant?.user?.name) {
    return null;
  }

  return (
    <div className="px-3 py-2 bg-blue-50 rounded-lg space-y-1">
      <p className="text-xs text-blue-600">{t("serviceProvidedBy")}</p>
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-medium text-blue-900 truncate">
          {consultant.user.name}
        </span>
        {(consultant.rating || consultant.totalRating) && (
          <div className="flex items-center gap-1 flex-shrink-0">
            <StarIcon className="w-3.5 h-3.5 text-yellow-500" />
            {consultant.rating && (
              <span className="text-xs font-semibold text-gray-700">
                {consultant.rating.toFixed(1)}
              </span>
            )}
            {consultant.totalRating && (
              <span className="text-xs text-gray-500">
                ({consultant.totalRating})
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultantBadge;
